import { NavLink,useNavigate } from "react-router-dom";
 

export default function SideMenu() {
  const navigate = useNavigate();

 const handleLogout = () => {
    localStorage.removeItem("auth");
    navigate("/login", { replace: true });
  };
  // ✅ SAME SOURCE as RoleRoute
  const auth = JSON.parse(localStorage.getItem("auth") || "{}");
  const role = (auth.role || "").toLowerCase().trim();

  const ADMIN_MENU = [
    { label: "Orders", path: "/pos/orders" },
    { label: "Sales Persons", path: "/pos/sales-persons" },
    { label: "Barcode", path: "/pos/barcode" },
    { label: "QR Settings", path: "/pos/qr" },
    { label: "Profile", path: "/pos/profile" },
  ];

  const SALES_MENU = [
    { label: "Sell", path: "/pos/sell" },
    { label: "Orders", path: "/pos/orders" },
    { label: "Profile", path: "/pos/profile" },
  ];

  const MENU = role === "admin" ? ADMIN_MENU : SALES_MENU;

  return (
    <nav className="p-4 space-y-2">
      {MENU.map((item) => (
        <NavLink
          key={item.path}
          to={item.path}
          className={({ isActive }) =>
            `block px-3 py-2 rounded ${
              isActive ? "bg-blue-100 text-blue-600" : "hover:bg-gray-100"
            }`
          }
        >
          {item.label}
        </NavLink>
      ))}

      <hr className="my-3" />

      <button
        onClick={handleLogout}
        className="w-full text-left px-3 py-2 rounded hover:bg-red-100 text-red-600 font-medium"
      >
        Logout
      </button>
    </nav>
  );
}
